<mat-toolbar color="primary">
    <button mat-icon-button aria-label="icon-button with menu icon" (click)="clickMenu.emit()">
        <mat-icon>menu</mat-icon>
    </button>
    <span class="spacer"></span>
    <div class="search-container">
        <div class="search-container-row">
            <input *ngIf="isDesktopMode || isSearchClicked" type="text" placeholder="Search Employee"
                [(ngModel)]="search" (ngModelChange)="searchTerm.next($event)" />
            <button (click)="isSearchClicked = !isSearchClicked" mat-icon-button
                aria-label="icon button with a vertical three dot icon">
                <mat-icon>search</mat-icon>
            </button>
        </div>
        <div *ngIf="isDesktopMode || isSearchClicked" class="serch-input-border"></div>
    </div>
</mat-toolbar>